String.prototype.replaceAll = function (search, replacement) {
  let target = this;
  return target.split(search).join(replacement);
};

String.prototype.padEnd = function (length, padChar) {
  if (!padChar) padChar = ' ';

  const padLength = length - this.length;

  if (padLength <= 0) return this;

  return this.concat(new Array(padLength + 1).join(padChar));
};
